import { Injectable } from "@angular/core";

@Injectable()
export class AppHeadersService {
    values: any;
}